// extracted by mini-css-extract-plugin
export default {"mid":"Mid_mid__nol5s","rightLine":"Mid_rightLine__Z7mN9"};